import { Flow } from 'signup-constants/Flow';
import { getIntentKey } from '../routing/getIntentKey';
import { isFlow } from '../utils/isFlow';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { enrollOnFlow } from './experimentDefaults';
import { getIsMobile } from '../utils/deviceUtils';
import { isBrowserAndApplicationLanguageForLocale } from '../i18n/LanguageUtils';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getPreferredLocale } from '../i18n/LocaleUtils';
import { isHubless } from '../store/existing-accounts/selectors';
import { getIsNewUserExperiment } from './ExperimentUtils';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ACQ0143, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const intentKey = getIntentKey();
    const isMobile = getIsMobile();
    const isFrenchLanguage = isBrowserAndApplicationLanguageForLocale(Locale.fr) || getPreferredLocale() === Locale.fr;
    const userIsHubless = isHubless(state);
    return isEnrolledFlow && !intentKey && !isMobile && !isFrenchLanguage && !userIsHubless;
  }
}], [ExperimentKeys.ACQ0145, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const intentKey = getIntentKey();
    const isMobile = getIsMobile();
    const isFrenchLanguage = isBrowserAndApplicationLanguageForLocale(Locale.fr) || getPreferredLocale() === Locale.fr;
    const userIsHubless = isHubless(state);
    return isEnrolledFlow && !intentKey && !isMobile && !isFrenchLanguage && !userIsHubless;
  }
}], [ExperimentKeys.ACQ0148, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm]);
    const isNewUser = getIsNewUserExperiment(state);
    return isEnrolledFlow && isNewUser;
  }
}], [ExperimentKeys.COAC0001, {
  shouldEnroll: state => {
    const isEnrolledFlow = isFlow([Flow.Crm, Flow.Marketing, Flow.Sales, Flow.Service]);
    const isNewUser = getIsNewUserExperiment(state);
    return isEnrolledFlow && isNewUser;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }
  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}